import { ServiceAlertApiClient } from '@/libs/ServiceAlertApiClient';
import { paramTypeEnum } from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';
import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';

export interface ConfirmServiceAlertResp extends GeneralResp {}
/**
 * @todo 確認延長訊息
 */
const ConfirmServiceAlert = (_url?: string | null): Promise<ConfirmServiceAlertResp> => {
    const url = _url || RouteUrlList.API_ConfirmServiceAlert.path;
    const config = {
        params: { showOverlay: paramTypeEnum.false, getServiceAlert: paramTypeEnum.true }
    };
    return ServiceAlertApiClient.post(url, {}, config).then((res: AxiosResponse<ConfirmServiceAlertResp>) => {
        return res.data;
    });
};

export default ConfirmServiceAlert;
